import { render } from "./PromSection.vue?vue&type=template&id=986966ea&scoped=true"
import script from "./PromSection.vue?vue&type=script&lang=js"
export * from "./PromSection.vue?vue&type=script&lang=js"

import "./PromSection.vue?vue&type=style&index=0&id=986966ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986966ea"]])

export default __exports__